import { LOAD_TABLE } from "../types/type";

const initialState = {
TableDetails: [],
};

const skutableReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOAD_TABLE:
      return {
        ...state,
        TableDetails: payload,
      };
    default:
      return state;
  }
};

export default skutableReducer;
